<div class="contract-details-view-container" *ngIf="contractBalanceObject" fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex="100" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <ng-container *ngIf="contractBalanceObject?.contractInitialBalances.length">
          <mat-card class="partners-add-card">
             <div fxLayout="row">
               <h3>Historia Salda</h3>
             </div>
            <table mat-table [dataSource]="contractBalanceObject?.contractInitialBalances">

              <ng-container matColumnDef="net">
                <th mat-header-cell *matHeaderCellDef>Kwota salda</th>
                <td mat-cell *matCellDef="let element">
                  {{element.initialBalanceNet | number:'1.2-2'}} zł
                </td>
              </ng-container>
              <ng-container matColumnDef="note">
                <th mat-header-cell *matHeaderCellDef>Uwagi</th>
                <td mat-cell *matCellDef="let element">
                  {{element.note}}
                </td>
              </ng-container>
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Data dodania</th>
                <td mat-cell *matCellDef="let element">
                  {{element.createdAt | date:'y-MM-dd'}}
                </td>
              </ng-container>
              <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
                <td mat-cell *matCellDef="let element">
                  <ng-container *ngIf="element.createdBy">
                    <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.username}}</a>
                  </ng-container>
                  <ng-container *ngIf="element.createdBy === null">
                    <a class="default-link">System</a>
                  </ng-container>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let element; let row; columns: displayedColumns;"></tr>
            </table>
          </mat-card>
          </ng-container>

        </div>
      </div>
    </div>
</div>
